var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.808 17.469L27.88 9H26.204L20.062 16.353L15.158 9H9.5L16.918 20.12L9.5 29H11.176L17.662 21.235L22.842 29H28.5L20.808 17.469ZM18.512 20.217L17.76 19.11L11.78 10.3H14.355L19.181 17.41L19.932 18.517L26.205 27.759H23.631L18.512 20.217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBX);
export default __webpack_public_path__ + "static/media/B_x.3b41b4366be0dc09e6d53a08f1192736.svg";
export { ForwardRef as ReactComponent };